/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} To_Typescript_Ref_H2Inputs */

const en_to_typescript_ref_h2 = /** @type {(inputs: To_Typescript_Ref_H2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inferred type`)
};

const ko_to_typescript_ref_h2 = /** @type {(inputs: To_Typescript_Ref_H2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`추론된 타입`)
};

const ja_to_typescript_ref_h2 = /** @type {(inputs: To_Typescript_Ref_H2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`推論された型`)
};

/**
* | output |
* | --- |
* | "Inferred type" |
*
* @param {To_Typescript_Ref_H2Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const to_typescript_ref_h2 = /** @type {((inputs?: To_Typescript_Ref_H2Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<To_Typescript_Ref_H2Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_to_typescript_ref_h2(inputs)
	if (locale === "ko") return ko_to_typescript_ref_h2(inputs)
	return ja_to_typescript_ref_h2(inputs)
});